//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const Styles = makeStyles((theme) => ({
    topGrid: {
        display: "flex",
        alignItems: "center",
        justifyContent: 'space-between'
    },
    searchInput: {
        width: 400,
        borderRadius: 20,
        "@media (max-width: 600px)": {
            width: "100%",
        },
    },
    searchInputIcon: {
        cursor: 'pointer',
    },
    tableSpan: {
        cursor: 'pointer'
    },
    exportBtn1: {
        color: "#fff",
        width: "120px",
        height: "35px",
        fontSize: "14px",
        cursor: "pointer",
        fontFamily: "segoe-ui",
        borderRadius: 5,
        backgroundColor: "#0a72ba",
        border: "none",
        // marginLeft:"38%",
    
        "@media (max-width: 600px)": {
          marginTop: "4rem",
        },
      },
      // CSVlink: {
      //   display: "none",
      // },
}))